// TODO: use full list on first party tool?
// import { countries as countriesListEN } from 'i18n-iso-countries/langs/en.json';
// import { countries as countriesListNL } from 'i18n-iso-countries/langs/nl.json';

const countriesListNL = {
  NL: 'Nederland',
  BE: 'België',
  DE: 'Duitsland',
  FR: 'Frankrijk',
  CH: 'Zwitserland',
  RO: 'Roemenië',
};
const countriesListEN = {
  NL: 'Netherlands',
  BE: 'Belgium',
  DE: 'Germany',
  FR: 'France',
  CH: 'Switzerland',
  RO: 'Romania',
};
const countriesListDE = {
  NL: 'Niederlande',
  BE: 'Belgien',
  DE: 'Deutschland',
  FR: 'Frankreich',
  CH: 'Schweiz',
  RO: 'Rumänien',
};

const countriesListRO = {
  NL: 'Olanda',
  BE: 'Belgia',
  DE: 'Germania',
  FR: 'Franța',
  CH: 'Elveția',
  RO: 'România',
};

export type CountryCode = keyof typeof countriesListEN;
export type CountryEntry = { code: CountryCode; label: string };

const getCountriesObject = (lang: string) => {
  if (lang === 'nl') return countriesListNL;
  if (lang === 'de') return countriesListDE;
  if (lang === 'ro') return countriesListRO;
  return countriesListEN;
};

export const getCountriesList = (lang = 'en'): CountryEntry[] => {
  const list = getCountriesObject(lang);

  return (Object.keys(list) as CountryCode[]).map((code) => {
    const countryName = list[code];
    const label = Array.isArray(countryName) ? countryName[0] : countryName;
    return { code, label };
  });
};

export const countryLabelToCode = (label: string, lang = 'en'): CountryCode => {
  const list = lang === 'nl' ? countriesListNL : countriesListEN;

  return (Object.keys(list) as CountryCode[]).find(
    (code) => list[code] === label
  ) as CountryCode;
};
